import { withCompInfo } from '@wix/editor-elements-integrations'
import { WFacebookCommentCSSVars, WFacebookCommentDefinition } from './WFacebookComment'
import { getHeightCSS } from '@wix/editor-elements-common-utils'

export const css = withCompInfo<WFacebookCommentCSSVars | {}, WFacebookCommentDefinition>()(
	['hasResponsiveLayout', 'compLayout', 'compSingleLayout'],
	({ hasResponsiveLayout, compLayout, compSingleLayout }) => {
		const height = getHeightCSS(compLayout, compSingleLayout)
		return !hasResponsiveLayout
			? {
					height: 'auto',
					'min-height': height,
			  }
			: {}
	}
)
